import './App.css';
import JsonEscaper from './pages/jsonEscaper';
import {BrowserRouter as  Router, Routes, Route } from "react-router-dom";
import NotFoundPage from './pages/notFoundPage';
import HomePage from './pages/home';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage/>} />
        <Route path="/home" component={<HomePage/>} />
        <Route path="/json-escaper" element={<JsonEscaper/>} />
        <Route path="*" element={<NotFoundPage/>} />
      </Routes>
    </Router>
  )
}

export default App;